/**
 * @generated SignedSource<<02fa196b8c4ddf7360083c2b5f112157>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CategoryRendererQuery$variables = {};
export type CategoryRendererQuery$data = {
  readonly allCategories: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly rowId: string;
        readonly title: string;
      } | null;
    }>;
  } | null;
};
export type CategoryRendererQuery = {
  response: CategoryRendererQuery$data;
  variables: CategoryRendererQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "condition",
        "value": {
          "active": true
        }
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 1000
      }
    ],
    "concreteType": "CategoriesConnection",
    "kind": "LinkedField",
    "name": "allCategories",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CategoriesEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Category",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rowId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "allCategories(condition:{\"active\":true},first:1000)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CategoryRendererQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CategoryRendererQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "47d175bf591e7743b5de7e4340ef2170",
    "id": null,
    "metadata": {},
    "name": "CategoryRendererQuery",
    "operationKind": "query",
    "text": "query CategoryRendererQuery {\n  allCategories(first: 1000, condition: {active: true}) {\n    edges {\n      node {\n        id\n        rowId\n        title\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fe96afd3aa993abc60d662a960323bfc";

export default node;
